import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "proptypes";
import tourradarlogo from "../../../assets/tourradar-trusted-badge.png";
import BBBLogo from "../../../assets/blue-seal-250-52-growth-international-volunteer-excursions-llc-22822011.png";
import "./Footer.scss";

const base = "https://www.givevolunteers.org/";

const Footer = ({ onLogout, pathname }) => (
  <footer className="app-footer">
    <div className="container footer-container">
      <div className="row">
        <div className="col-md-6">
          <div className="col-md-6 col-sm-6">
            <h4>Volunteer Profile</h4>
            {window.localStorage.sessionToken ? (
              <ul>
                <li>
                  <Link to="/portal-home#top">My Trips</Link>
                </li>
                <li>
                  <Link to="/portal-home#add-ons">Extend Your Trip</Link>
                </li>
                <li>
                  <Link to="/trip-selection">Select a Trip</Link>
                </li>
                <li>
                  <Link to="/profile#past-trips">See Trip History</Link>
                </li>
                <li>
                  <Link to="/portal-home#invite-friends">Invite Friends to Join</Link>
                </li>
                <li>
                  <Link to="/profile#top">My Profile</Link>
                </li>
                <li>
                  <a
                    href="#logout"
                    onClick={(e) => {
                      e.preventDefault();
                      onLogout();
                    }}
                  >
                    Logout
                  </a>
                </li>
              </ul>
              ) : (
              <ul>
                <li>
                  <Link to="/">Login</Link>
                </li>
                <li>
                  <Link to="/sign-up">Apply</Link>
                </li>
              </ul>
            )}
          </div>
          <div className="col-md-6 col-sm-6">
            <h4>GIVE Website</h4>
            <ul>
              <li>
                <a
                  href={`${base}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Home Page
                </a>
              </li>
              <li>
                <a
                  href={`${base}contact/`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6 col-sm-6">
          <div className="col-md-6 col-sm-6">
            <a
              href="https://www.tourradar.com/growth-international-volunteer-excursions"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img src={tourradarlogo} className="App-logo" alt="logo" />
            </a>
          </div>
          <div className="col-md-6 col-sm-6">
            <div className="logoAndText">
              <a
                href="https://www.tourradar.com/growth-international-volunteer-excursions"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span>
                  <img
                    src={BBBLogo}
                    alt="Growth International Volunteer Excursions LLC BBB Business Review"
                  />
                  <h5>BBB Rating: A+!</h5>
                  <p>As of 11/28/2017</p>
                  <p>Click for Profile</p>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  onLogout: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired
};

export default Footer;
